<template>
    <el-select v-model="value">
      <el-option 
        v-for="item in LevelData" 
        :key="item.id"
        :value="item.id"
        :label="item.name"
      ></el-option> 
    </el-select>
</template>

<script>

import { getLevelList } from '@/http/modules/baseSet/majorCourse';


export default {
  name: 'Level',
  data() {
    return {
      LevelData: [],
      value: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      getLevelList().then(res => {
        this.LevelData = res.data;
      })
    }
  }
}
</script>

<style>

</style>